import { t } from 'i18next';

import { getExcelFile } from '@sophocles/utils';

/**
 * Build an Excel file for a report grid.
 *
 * @param {Object}   options
 * @param {string}   options.title           Title row at the top of the sheet.
 * @param {string}   options.fileName        Base file name (no extension/timestamp).
 * @param {Array}    options.rows            Array of row objects (plain JS) or Immutable list.
 * @param {Array}    options.columns         DataGridPro column defs (need `field` + `headerName`).
 * @param {Object}   options.siteGroup       Selected site group — plain JS object or Immutable map.
 * @param {boolean}  options.isBillboard     Toggles "Plant"/"Site Group" label.
 * @param {Array}    [options.subHeaderRows] Extra header rows inserted between scope + columns.
 */
export function exportReportToExcel({ title, fileName, rows, columns, siteGroup, isBillboard, subHeaderRows = [] }) {
  if (!rows || (Array.isArray(rows) ? rows.length === 0 : rows.size === 0)) return;

  const readField = (key, fallback = '') =>
    typeof siteGroup?.get === 'function' ? siteGroup.get(key, fallback) : (siteGroup?.[key] ?? fallback);

  const scopeLabel = isBillboard ? t('general.plant', 'Plant') : t('general.siteGroup', 'Site Group');
  const scopeName = readField('name');
  const scopeDesc = readField('description');
  const scopeLine = `${scopeLabel}: ${scopeName}${scopeDesc ? `. ${scopeDesc}` : ''}`;

  const headerRows = [[title], [scopeLine], ...subHeaderRows, [], columns.map(col => col.headerName)];

  const dataColumns = columns.map(col => col.field);
  getExcelFile(rows, dataColumns, headerRows, `${fileName}-${Date.now()}`);
}
